import { type ComponentPropsWithRef } from "react";
import { Root as LabelRoot } from "@radix-ui/react-label";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const labelVariants = cva(
  `
    text-sm leading-none
    peer-disabled:cursor-not-allowed peer-disabled:opacity-70
  `,
  {
    variants: {
      variant: {
        /** Primary form labels (e.g. FieldViewWrapper). */
        default: "font-medium",
        /** Muted caption for inline editor / directive slots (no bg-muted). */
        caption: "font-normal text-foreground/45",
        /** Console field labels (editor forms under data-theme=content). */
        console: `
          text-(length:--console-type-subtitle) font-medium
          text-(--console-text-label)
        `,
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

const Label = ({
  className,
  variant,
  ref,
  ...props
}: ComponentPropsWithRef<typeof LabelRoot> &
  VariantProps<typeof labelVariants>) => (
  <LabelRoot
    ref={ref}
    className={cn(labelVariants({ variant }), className)}
    {...props}
  />
);
Label.displayName = LabelRoot.displayName;

export { Label };
